<template>
  <b-modal
    :id="`repeat-checkin${id}`"
    modal-class="modal-style"
    ref="modal"
    v-model="modal"
  >
    <template>
      <p class="modal-style-title alert-title">重複報到</p>
      <div class="modal-style-content">
        <p>喔喔，你已經報到過了啦</p>
        <p>快進教室上課囉</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`repeat-checkin${this.id}`);
    }
  }
};
</script>
